import React from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";

const containerStyle = {
  width: "100%",
  height: "500px",
};

const libraries = ['places', 'geometry'];

export const GoogleMapComponent = ({ properties, mapOptions }) => {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    // eslint-disable-next-line no-undef
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_API_KEY,
    libraries,
  });


  if (!isLoaded) return <div>Loading...</div>;

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      options={mapOptions || {}}
      onLoad={(map) => {
        const bounds = new window.google.maps.LatLngBounds();
        properties.forEach((property) => {
          bounds.extend(property.position);
        });
        map.fitBounds(bounds, { top: 50, bottom: 50, left: 50, right: 50 });
      }}
    >
      {properties.map((property, idx) => (
        <Marker
          key={idx}
          position={property.position}
          title={property.title}
          label={{
            text: property.label,
            color: "white",
            fontWeight: "bold",
          }}
          icon={{
            path: window.google.maps.SymbolPath.POINTS,
            fillColor: property.color,
            fillOpacity: 1,
            strokeColor: "white",
            strokeWeight: 2,
            scale: property.isSubject ? 10 : 8,
          }}
          zIndex={property.isSubject ? 2 : 1}
        />
      ))}
    </GoogleMap>
  );
};

